export function StatCard({ label, value, sub, tone, testId }) {
  const toneCls = tone === "up" ? "up" : tone === "down" ? "down" : "text-white";
  return (
    <div className="panel px-3 py-2.5 min-w-0" data-testid={testId}>
      <div className="panel-title truncate">{label}</div>
      <div className={`mono text-base xl:text-xl font-semibold mt-1 truncate ${toneCls}`}>{value}</div>
      {sub && <div className="text-[11px] text-[#848e9c] mono mt-0.5 truncate">{sub}</div>}
    </div>
  );
}
